import { useEffect } from "react";

/**
 * Injects a `<script type="application/ld+json">` structured-data block into
 * document.head for the lifetime of the calling component, removing it on
 * unmount. Renders nothing itself — mount it anywhere in a public detail
 * page's tree.
 */
export function JsonLd({ data }: { data: Record<string, unknown> }) {
  // Depend on the serialised content rather than the object reference so a
  // parent re-render with an equivalent-but-new object literal doesn't tear
  // down and recreate the tag on every render.
  const json = JSON.stringify(data);

  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.textContent = json;
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, [json]);

  return null;
}
